<template>
    <div v-if="!loading">
        <div class="text-right mb-4">
            <Button @click.prevent="guardarPrecios(zonas)">Guardar todos</Button>
        </div>
        <template v-for="(zona, index) in zonas">
            <div class="row mb-4" :key="index">
                <div class="col-7 col-md-10">
                    <div class="row">
                        <div class="col-12 col-md-2">
                            <strong>{{ zona.nombre }}</strong>
                        </div>
                        <div class="col-12 col-md-2">
                            <div class="row">
                                <div class="col-6">
                                    <i class="text-green fas fa-store mr-2"></i>
                                    <a
                                        href=""
                                        v-if="zona.activar_taquilla"
                                        @click.prevent="
                                            zona.activar_taquilla = 0
                                        "
                                    >
                                        <i class="far fa-check-square"></i>
                                    </a>
                                    <a
                                        href=""
                                        v-else
                                        @click.prevent="
                                            zona.activar_taquilla = 1
                                        "
                                    >
                                        <i class="far fa-square"></i>
                                    </a>
                                </div>
                                <div class="col-6">
                                    <i
                                        class="text-green fas fa-laptop mr-2"
                                    ></i>
                                    <a
                                        href=""
                                        v-if="zona.activar_online"
                                        @click.prevent="zona.activar_online = 0"
                                    >
                                        <i class="far fa-check-square"></i>
                                    </a>
                                    <a
                                        href=""
                                        v-else
                                        @click.prevent="zona.activar_online = 1"
                                    >
                                        <i class="far fa-square"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div>
                                <label for="precio_taquilla" v-if="index === 0">Precio Taquilla:</label>
                            </div>
                            <multiselect
                                v-model="zona.precios_taquilla"
                                placeholder="Precios taquilla"
                                :id="'precio-taquilla-' + index"
                                :custom-label="labelTaquilla"
                                label="label_con_gd"
                                track-by="id"
                                :options="precios_formated"
                                :multiple="true"
                                @select="change($event, index, true)"
                            />
                        </div>
                        <div class="col-12 col-md-4">
                            <div>
                                <label for="precios_online" v-if="index === 0">Precios Online:</label>
                            </div>
                            <multiselect
                                v-model="zona.precios_online"
                                placeholder="Precios online"
                                :id="'precio-online-' + index"
                                :custom-label="labelOnline"
                                label="label_sin_gd"
                                track-by="id"
                                :options="precios_formated"
                                :multiple="true"
                                @select="change($event, index, false)"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-5 col-md-2 text-right">
                    <Button @click.prevent="guardarPrecios([zona])">Guardar</Button>
                </div>
            </div>
        </template>
    </div>
    <div v-else>
        <div class="card-body">
            <LoaderComponent/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PricesTableComponent',
        props: ['evento_id', 'sesion', 'precios', 'tipo', 'ambos'],
        data() {
            return {
                expand: [],
                zonas: [],
                loading: false,
            }
        },
        computed: {
            precios_formated() {
                var array = []

                for (var i = 0; i < this.precios.length; i++) {
                    if (
                        (this.tipo == 'abonado' && this.precios[i].dia_abonado) ||
                        (this.tipo != 'abonado' && !this.precios[i].dia_abonado)
                    ) {
                        array.push(this.precios[i])
                    }
                }

                return array
            },
        },
        created() {
            this.getZonas()
        },
        methods: {
            // Asigna el valor seleccionado al contrario, si cambió taquilla lo asigna a online.
            change(selectedOption, index, taquilla) {
                if (!this.ambos) return

                const zona = this.zonas[index]
                const precios = taquilla
                    ? zona.precios_online
                    : zona.precios_taquilla

                precios.push(selectedOption)
            },
            labelTaquilla({
                descripcion,
                precio_total,
                precio,
                zona,
                price_management_taquilla_interno,
                price_management_taquilla,
            }) {
                var total = parseFloat(precio) + price_management_taquilla

                if (price_management_taquilla_interno == 1) {
                    return (
                        descripcion +
                        ' - (' +
                        parseFloat(precio).toFixed(2) +
                        '€' +
                        ')' +
                        ' - (' +
                        zona +
                        ')'
                    )
                } else {
                    return (
                        descripcion +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')' +
                        ' - (' +
                        zona +
                        ')'
                    )
                }
            },
            labelOnline({
                descripcion,
                precio_total,
                precio,
                zona,
                price_management_online_interno,
                price_management_online,
            }) {
                var total = parseFloat(precio) + price_management_online

                if (price_management_online_interno == 1) {
                    return (
                        descripcion +
                        ' - (' +
                        parseFloat(precio).toFixed(2) +
                        '€' +
                        ')' +
                        ' - (' +
                        zona +
                        ')'
                    )
                } else {
                    return (
                        descripcion +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')' +
                        ' - (' +
                        zona +
                        ')'
                    )
                }
            },
            guardarPrecios(zonas) {
                this.loading = true

                for (var i in zonas) {
                    var precios_online = []
                    var precios_taquilla = []
                    for (var x in zonas[i].precios_online) {
                        precios_online.push(zonas[i].precios_online[x].id)
                    }

                    for (var z in zonas[i].precios_taquilla) {
                        precios_taquilla.push(zonas[i].precios_taquilla[z].id)
                    }

                    zonas[i].precios_online = precios_online
                    zonas[i].precios_taquilla = precios_taquilla
                }

                const params = {
                    filters: {
                        tipo: this.tipo,
                    },
                    data: zonas,
                    sesion_id: this.sesion.id,
                    evento_id: this.evento_id,
                    tipo: this.tipo,
                }

                this.$store
                    .dispatch(
                        this.config.getVuexAlias(
                            'back.events.sesiones.zonas.editar'
                        ),
                        params
                    )
                    .then(res => {
                        this.zonas = res.data
                        this.getZonas()
                    })
            },
            getZonas() {
                this.loading = true

                const params = {
                    filters: {
                        tipo: this.tipo,
                    },
                    sesion_id: this.sesion.id,
                    evento_id: this.evento_id,
                    tipo: this.tipo,
                }

                this.$store
                    .dispatch(
                        this.config.getVuexAlias('back.events.sesiones.zonas'),
                        params
                    )
                    .then(res => {
                        this.zonas = res.data.zonas
                        for (var i in this.zonas) {
                            this.setPrecios('online', i)
                            this.setPrecios('taquilla', i)
                        }
                    })
                    .finally(() => (this.loading = false))
            },
            setPrecios(tipo, index) {
                var index_precio = ''
                var index_disponible = ''

                switch (tipo) {
                    case 'online':
                        index_precio = 'precios_online'
                        index_disponible = 'precios_online'
                        break
                    case 'taquilla':
                        index_precio = 'precios_taquilla'
                        index_disponible = 'precios_taquilla'
                        break
                }

                for (var x in this.zonas[index][index_precio]) {
                    for (var e in this.precios) {
                        if (
                            this.precios[e].id ==
                            this.zonas[index][index_disponible][x]
                        ) {
                            this.zonas[index][index_precio][x] = this.precios[e]
                            break
                        }
                    }
                }
            },
        },
    }
</script>
